import { registerGlobalComponents } from './component'
import { setupVbenForm } from './form'
import { setupVbenVxeTable } from './vxe-table'

export function setupAdapter() {
  registerGlobalComponents()
  setupVbenForm()
  setupVbenVxeTable()
}
